export enum Hyperlinks {
  GITHUB = 'https://github.com/rutbergphilip',
  LINKEDIN = 'https://www.linkedin.com/in/philiprutberg/',
  INSTAGRAM = 'https://www.instagram.com/rutbergphilip/',
  POSTNORD = 'https://www.postnord.com/',
}
